import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const footerLinks = {
  company: [
    { name: 'Services', path: '/services' },
    { name: 'Contact', path: '/quote' },
  ],
  services: [
    { name: 'Web Design', path: '/services' },
    { name: 'Branding', path: '/services' },
    { name: 'SEO', path: '/services' },
    { name: 'AI Automation', path: '/services' },
  ],
  contact: [
    { icon: Mail, text: 'tegosdigital@gmail.com' },
    { icon: Phone, text: '224 247 9682' },
    { icon: MapPin, text: 'United States' },
  ],
};

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#050505] border-t border-[#1F1F22]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <div className="w-11 h-11 rounded-xl overflow-hidden bg-[#0a0a0a] flex items-center justify-center p-1">
                <img 
                  src="https://customer-assets.emergentagent.com/job_creative-agency-75/artifacts/y4n317ge_Tata%20Digital%20Logo.jpg" 
                  alt="Tegos Digital"
                  className="w-full h-full rounded-lg object-contain"
                />
              </div>
              <span className="text-xl font-semibold text-white font-['Clash_Display']">
                Tegos Digital
              </span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              We create stunning websites and powerful digital marketing strategies that drive real results for your business.
            </p>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-white font-semibold mb-6 font-['Clash_Display']">Company</h4>
            <ul className="space-y-4">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    data-testid={`footer-${link.name.toLowerCase()}`}
                    className="text-slate-400 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="text-white font-semibold mb-6 font-['Clash_Display']">Services</h4>
            <ul className="space-y-4">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-6 font-['Clash_Display']">Contact</h4>
            <ul className="space-y-4">
              {footerLinks.contact.map((item, index) => (
                <li key={index} className="flex items-center gap-3 text-slate-400 text-sm">
                  <item.icon size={16} className="text-blue-500" />
                  <span>{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[#1F1F22] flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Tegos Digital. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="text-slate-500 hover:text-white text-sm transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="text-slate-500 hover:text-white text-sm transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
